<template>
  <v-data-table
    :headers="headers"
    hide-actions
    :items="data"
    class="elevation-1 "
    :expand="expand"
  >
    <template v-slot:items="props">
      <tr :class="`projet ${props.item.status}`" @click="props.expanded = !props.expanded">
          <td class="text-xs-left font-weight-bold" >{{ props.item.type }}</td>
          <td class="text-xs-left font-weight-bold" >{{ props.item.currency }}</td>
        <td v-if="props.item.devise=='cfa'" class="text-xs-left font-weight-bold">{{ new Intl.NumberFormat("fr-FR",{maximumFractionDigits:0}).format(props.item.amount)}}</td>
        <td v-if="intCurrences.includes(props.item.currency)" class="text-xs-left font-weight-bold">{{ new Intl.NumberFormat("fr-FR",{maximumFractionDigits:0}).format(props.item.amount)}}</td>
        <td v-if="twoDigitCurrencies.includes(props.item.currency)" class="text-xs-left font-weight-bold">{{ new Intl.NumberFormat("fr-FR",{maximumFractionDigits:2}).format(props.item.amount)}}</td>
        <td v-if="fourDigitCurrencies.includes(props.item.currency)" class="text-xs-left font-weight-bold">{{ new Intl.NumberFormat("fr-FR",{maximumFractionDigits:4}).format(props.item.amount)}}</td>
        <td v-if="props.item.currency=='BTC'" class="text-xs-left font-weight-bold">{{ new Intl.NumberFormat("en-US",{maximumFractionDigits:6}).format(props.item.amount)}}</td>
        <!-- 'btc withdraw' -->
        <!-- 'btc deposit' -->
        <td class="font-weight-bold"><v-chip small :class="`${props.item.status} white--text`">{{ props.item.status }}</v-chip> </td>
        <!-- <td class="text-xs-left font-weight-bold">{{props.item.created_at.toDate().toLocaleTimeString('fr-FR', { day: 'numeric', month: 'numeric',year:'numeric'})}}</td> -->
      </tr>
      <v-divider></v-divider>
    </template>
    <template v-slot:expand="props">
      
     
                <tr>
                  <td>DONNEZ </td>
                  <td>
                    {{props.item.give_amount}} {{props.item.give}} {{props.item.give_network? props.item.give_network :''}}
                  </td>
                </tr>
                 <vs-tr >
                  <vs-td>RECEVEZ </vs-td>
                  <vs-td>
                    {{props.item.amount}} {{props.item.currency}} {{props.item.network? props.item.network :''}}
                  </vs-td>
                </vs-tr>
                <vs-tr v-if="props.item.network">
                  <vs-td>Adresse </vs-td>
                  <vs-td>
                    {{props.item.address}}
                  </vs-td>
                </vs-tr>

                <tr v-if="props.item.hash" @dblclick="open_explorer(props.item)" @click="copy_hash(props.item.hash)">
                  <td>HASH </td>
                  <td >
                    {{props.item.hash}}
                  </td>
                </tr>

                <tr v-if="props.item.batch" >
                  <td>BATCH </td>
                  <td >
                    {{props.item.batch}}
                  </td>
                </tr>

                <vs-tr v-if="props.item.give_network || props.item.numero">
                  <vs-td>Numero </vs-td>
                  <vs-td>
                    {{props.item.address}}
                  </vs-td>
                </vs-tr>

                 <vs-tr>
                  <vs-td>DATE</vs-td>
                  <vs-td>
                   {{props.item.created_at.toDate().toLocaleTimeString('fr-FR', { day: 'numeric', month: 'numeric',year:'numeric'})}}
                  </vs-td>
                </vs-tr>

                <vs-tr>
                  <vs-td>STATUT</vs-td>
                  <vs-td >
                   <v-chip small :class="`${props.item.status} white--text`">{{ props.item.status }}</v-chip>
                  </vs-td>
                </vs-tr>

                 <div v-if="props.item.deposit_address && props.item.status == 'attente'" style="text-align:center;">
                  <v-flex text-xs-center xs12>
                      <p class="caption red--text"> Envoyez uniquement {{props.item.give}} {{props.item.give_network}} à cette adresse</p>
                       <span>MONTANT: </span><h3 style="display:inline-block;">{{props.item.give_amount}} {{props.item.give}} {{props.item.give_network}} </h3> <br>
                      <div @click="copy(props.item.deposit_address)" style="cursor:pointer;">
                        <qrcode-vue  class="mt-3" :value="props.item.deposit_address" size="170" level="H"></qrcode-vue>
                      </div>
                      <br />
                      <p @click="copy(props.item.deposit_address)" style="cursor:pointer;">{{props.item.deposit_address}}</p>
                      <p class="caption green--text" v-if="copied" style="line-height:30%;">Adresse copié avec success!</p>
                      <p class="caption" v-if="!copied"  @click="copy(props.item.deposit_address)" style="cursor:pointer;line-height:50%;">cliquer sur l'adresse ou le QR pour copier</p>
                      <p class="caption" v-if="!copied" > Cette operation est automatique et ne necessite <br> aucune action apres le paiement</p>
                    </v-flex>
                </div>

                <div v-if="props.item.payment_url && props.item.status == 'attente'" style="text-align:center;">
                  <v-flex text-xs-center xs12>
                      <div  v-if="!['PAYEER','ADV'].includes(props.item.give)" @click="open(props.item.payment_url)" style="cursor:pointer;">
                        <p class="caption">Scannez ou Cliquez ce Code Qr pour payer par {{ props.item.give }}</p>
                        <qrcode-vue  class="mt-3" :value="props.item.payment_url" size="170" level="H"></qrcode-vue>  
                      </div>
                      
                      <br />
                      <span  @click="open(props.item.payment_url)" style="cursor:pointer;line-height:10%;">{{props.item.give }} <br>
                        <img v-if="props.item.give.startsWith('WAVE')"  width="50" class="pl-1" height="50" src="/img/wave.png" alt="">
                        <img v-if="props.item.give.startsWith('OM')"  width="50" class="pl-1" height="50" src="/img/orange.svg" alt="">
                        <img v-if="props.item.give.startsWith('MOOV')"  width="50" class="pl-1" height="50" src="/img/moov.png" alt="">
                        <img v-if="props.item.give.startsWith('PAYEER')"  width="50" class="pl-1" height="50" src="/img/payeer.png" alt="">
                       </span>
                       <p class="caption green--text" v-if="copied" style="line-height:30%;">lien copié avec success!</p>
                      <p class="caption mt-2" v-if="props.item.give.startsWith('WAVE')" @click="copy(props.item.payment_url)" style="cursor:pointer;line-height:10%;"><v-btn color="success">Copier le lien du paiement</v-btn></p>
                      <p class="caption mt-2" v-if="!props.item.give.startsWith('WAVE')"  @click="open(props.item.payment_url)" style="cursor:pointer;line-height:10%;"><v-btn color="primary">Cliquer pour payer</v-btn></p>
                    </v-flex>
                </div>
      </template>
  </v-data-table>
</template>

<script>
const copy = require('clipboard-copy')
import { mapGetters, mapActions } from "vuex";
  export default {

    data () {
      return {
          headers:[],
          expand:false,
          copied:false,
          twoDigitCurrencies : ['USDT','PM','PAYEER', 'ADV','TRX'],
          fourDigitCurrencies : ['BNB', 'SOL', 'TON'],
          intCurrences: ['CFA', 'SHIB', 'HMSTR', 'cfa']
      }
    },
    computed: {
        ...mapGetters({
      data: "exchanged/recent_transactions"
    })
        
    },

    mounted () {
        this.bind_recent_transactions();
    },
    methods: {
      gethash(item) {
        item.hash?window.open(`https://www.blockchain.com/fr/btc/tx/${item.hash}`): ''
        item.btcAddr?window.open(`https://www.blockchain.com/fr/btc/address/${item.btcAddr}`): ''
      },

      open_explorer(item){
        console.log(item);
        item.network == 'TRX'? window.open(`https://tronscan.org/#/transaction/${item.hash}`): ''
        item.network == 'BSC'? window.open(`https://bscscan.com/tx/${item.hash}`): ''
      },

      open(url){
        window.open(url)
      },

      copy(address){
          copy(address)
          this.copied = true
          setTimeout(() => {
            this.copied = false
          }, 5000);
        },

        copy_hash(address){
          copy(address)
          swal('hash copié')
        },
      ...mapActions("exchanged", ["bind_recent_transactions"]),
    },
    }
</script>
<style scoped>
table.v-table thead tr th {
  font-size: 1.2em;
}
table.v-table tbody tr td {
  font-size: 15px;
}
</style>
<style>
 .v-chip.awaiting{
  background: #ffaa2c;
}
.v-chip.complete{
  background: #5b9b47;
}
 .v-chip.attente{
  background: #ffaa2c;
}
 .v-chip.Attente{
  background: #ffaa2c;
}
.v-chip.declined{
  background: rgb(201, 120, 120);
}
.projet.awaiting{
  border-left: 7px solid #ffaa2c;
}
.projet.Attente{
  border-left: 7px solid #ffaa2c;
}
.projet.attente{
  border-left: 7px solid #ffaa2c;
}
.projet.complete{
  border-left: 7px solid #5b9b47;
}
.projet.declined{
  border-left: 7px solid rgb(201, 120, 120);
}
</style>
